import { render, staticRenderFns } from "./UpGrade.vue?vue&type=template&id=facdb2f4&scoped=true"
import script from "./UpGrade.vue?vue&type=script&lang=js"
export * from "./UpGrade.vue?vue&type=script&lang=js"
import style0 from "./UpGrade.vue?vue&type=style&index=0&id=facdb2f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facdb2f4",
  null
  
)

export default component.exports